import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CardContent } from '@models/card-content';
import { CookieService } from 'ngx-cookie-service';
import { Observable, catchError, map, of } from 'rxjs';
import { HUBSPOT_FEED } from '../app.token';

/** service to pull latest news from rss feed */
@Injectable( {
    providedIn: 'root'
} )
export class NewsService {
    /** ignore in coverage */
    #httpClient = inject( HttpClient );
    #cookieService = inject( CookieService );
    #hupspotFeed = inject( HUBSPOT_FEED );
    /**
     * get rss feed
     * reduce the incoming feed to a given number of items
     * and provide response as json object
     *
     * @param {string} feed - type of news feed
     * @param {number} count - number of news items to return
     * @returns array of News objects with length of count
     */
    getRSSNews( feed: string, count: number ): Observable<CardContent[]> {
        const lang = this.getFeedLanguage();
        const hubspotFeedUrl = `${this.#hupspotFeed}/${lang}/${feed}/json`;

        return this.#httpClient.get<CardContent[]>( hubspotFeedUrl )
            .pipe(
                map( ( response: any ) => {
                    return response.slice( 0, count );
                } ),
                catchError( ( error ) => {
                    console.error( error );
                    return of( [] );
                } )
            );
    }

    /**
     * match user language with feeds
     * @returns {string} language code for feed
     */
    getFeedLanguage(): string {

        const cookieExists: boolean = this.#cookieService.check( 'language' );
        const lang = cookieExists ? this.#cookieService.get( 'language' ) : navigator.language;

        switch ( lang.slice( 0, 2 ) ) {
            case 'de':
                return 'de';
            // case 'es':
            //     return 'es';
            // case 'nl':
            //     return = 'nl';
            default:
                return 'en';
        }
    }
}
